import { Component } from '@angular/core';

import { UpdateCustomerComponent } from '../update-customer/update-customer.component';
import { AssignPlanComponent } from '../assign-plan/assign-plan.component';
import { ListCustomerPlansComponent } from '../list-customer-plans/list-customer-plans.component';
@Component({
    selector: 'app-customer-plans',
    templateUrl: './customer-plans.component.html',
    styleUrls: ['./customer-plans.component.css'],
    imports: [UpdateCustomerComponent, AssignPlanComponent, ListCustomerPlansComponent]
})
export class CustomerPlansComponent {
  customerData: any;
  
  ngOnInit() {
    this.customerData = history.state.customerData;
  }
}
